export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    shouldShowSubtitle() {
      return !!this.subtitle;
    },
    shouldShowTitle() {
      return !!this.title;
    },
  },
};
